import {useNavbar} from 'shared/hooks/useNavbar';

import {LandingPageFooter} from 'shared/pages/LandingPage/LandingPageFooter';
import {HeroSection} from 'shared/pages/LandingPage/HeroSection/HeroSection';
import {ISlide, ScrollShowcase} from 'shared/pages/LandingPage/ScrollShowcase/ScrollShowcase';
import {AlumniSection, IAlumni} from 'shared/pages/LandingPage/AlumniSection/AlumniSection';
import {FestivalSection} from './FestivalSection/FestivalSection';
import {CoursesSection} from './CoursesSection/CoursesSection';
import {FinalCtaSection} from './FinalCTASection/FinalCTASection';
import {currentCourses} from 'shared/utils/course-preview/course-previews';

import './styles.scss';

const slides: ISlide[] = [
    {
        heading: 'Modules packed with Real Content',
        image: '/assets/images/LandingPage/ScrollShowcase/Course-Home.png',
    },
    {
        heading: 'Curated Resources at Every Step',
        image: '/assets/images/LandingPage/ScrollShowcase/Course-Image-1.png',
    },
    {
        heading: 'Tied to the Sustainable Development Goals',
        image: '/assets/images/LandingPage/ScrollShowcase/Course-Image-2.png',
    },
    {
        heading: 'From Idea to Product Creation',
        image: '/assets/images/LandingPage/ScrollShowcase/Course-Image-3.png',
    },
    {
        heading: 'And the Nitty-Gritty of Accounting',
        image: '/assets/images/LandingPage/ScrollShowcase/Course-Image-4.png',
    },
];

const alumniList: IAlumni[] = [
    {
        name: 'Jemima',
        role: '2024 Young Innovator of the Year',
        quote: 'I\'ve become a lot more confident when speaking in front of large crowds',
        image: '/assets/images/LandingPage/AlumniSection/Jemima.jpg',
    },
    {
        name: 'James',
        role: 'Founder of JT Butterflies',
        quote: 'What I learned here was priceless – both in knowledge and connections.',
        image: '/assets/images/LandingPage/AlumniSection/James.jpg',
    },
    {
        name: 'Mido',
        role: 'Founder of English First',
        quote: 'You learn a lot of skills throughout preparing the pitches, thinking through your ideas and making PowerPoints.',
        image: '/assets/images/LandingPage/AlumniSection/Mido.jpg',
    },
];

export const LandingPage = () => {
    useNavbar(true);
    return (
        <>
            <HeroSection />
            <FestivalSection />
            <CoursesSection currentCourses={currentCourses} />
            <ScrollShowcase slides={slides} />
            <AlumniSection alumniList={alumniList} />
            <FinalCtaSection />
            <LandingPageFooter />
        </>
    );
};